import { FC, ComponentProps, KeyboardEvent, ReactNode } from 'react';
import { StyledButton } from '../StyledButton';

const KEYBOARD_ENTER = 'Enter';

type Props = {
  show?: boolean;
  enable?: boolean;
  onClickCallback?: () => void;
  label?: string;
  children?: ReactNode;
} & ComponentProps<typeof StyledButton>;

export const ConfirmButton: FC<Props> = ({ show, enable, onClickCallback, label, children, ...otherProps }) => {
  function onClickConfirm() {
    if (enable) onClickCallback?.();
  }

  function onKeyDown(event: KeyboardEvent<HTMLButtonElement>) {
    if (event?.key === KEYBOARD_ENTER) {
      event.preventDefault();
      onClickConfirm();
    }
  }

  const ariaLabel = enable ? label : 'Revise la información ingresada';

  return (
    <StyledButton
      variant={enable ? 'primary' : ''}
      onClick={onClickConfirm}
      onKeyDown={onKeyDown}
      display={show ? '' : 'none'}
      aria-hidden={!show}
      width="fit-content !important"
      marginTop="0"
      px="16px !important"
      py="12px !important"
      color={enable ? '' : 'white'}
      bg={enable ? '' : 'secondary.0'}
      borderRadius="3px 8px 3px 8px"
      blocked={!enable}
      title={ariaLabel}
      aria-label={ariaLabel}
      {...otherProps}
    >
      {children ?? label}
    </StyledButton>
  );
};